<!-- index -->
<template>
  <div id='indexPage'>
    <div class="app-container">
      <router-view />
    </div>
    <div class="footer">
        <p class="copyright">Copyright © ️2024 好未来版权所有 北京乐柏教育咨询有限公司</p>
        <p class="backup" @click="goDetail">京ICP备09036231号-8 京公网安备11010502056224</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'stu',
  data () {
    return {}
  },
  created () {

  },
  mounted () {},
  methods: {
    goDetail () {
      // window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14102102000119')
      // window.open('https://beian.miit.gov.cn/')
      window.open('https://beian.mps.gov.cn/#/query/webSearch?code=11010502056224')
    }
  }
}
</script>
<style scoped lang='scss'>
#indexPage {
  width: 100%;
  min-width: $main-width;
  margin: 0 auto;
  .app-container {
  }
  .footer {
      position: fixed;
      bottom: 30px;
      width: 100%;
  }
}
</style>
